module.exports = __webpack_public_path__ + "media/images/emblems/Bogis-Bossey-coat_of_arms-c8f90e2a84db90b9a2166ada3d07286f.svg";